import React from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import Tooltip from 'chameleon/ui-stack/ui/base/tooltip';

const CONSTANTS = {
  LABEL: 'Search Tips',
  TARGET: 'search-tips-button',
  TOOLTIP: 'Improve your results with these search operators',
};

const SearchTips = ({ onClick, isIcon, isLink }) => (
  <Tooltip target={CONSTANTS.TARGET} description={CONSTANTS.TOOLTIP}>
    <ButtonWithIcon
      isLink={isLink}
      isNaked
      isIcon={isIcon}
      size="medium"
      icon={isLink ? 'info_outline_filled' : 'info_outline'}
      iconWidth={18}
      iconHeight={18}
      iconClassName={isLink ? null : 'text-gray-600'}
      onClick={onClick}
      iconAccessibility={{
        ariaHidden: true,
      }}
    >
      {isIcon ? null : CONSTANTS.LABEL}
    </ButtonWithIcon>
  </Tooltip>
);

SearchTips.propTypes = {
  onClick: PropTypes.func,
  isIcon: PropTypes.bool,
  isLink: PropTypes.bool,
};

SearchTips.defaultProps = {
  onClick: () => {},
  isIcon: false,
  isLink: false,
};

export default SearchTips;
